module.exports = __webpack_public_path__ + "img/10-10.83d5535e.jpg";